import { AppConfig, usePermissions } from '@ltvco/refresh-lib/ctx';
import { useFirstRecordSearchRedirect } from '@ltvco/refresh-lib/utils';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { getFreemiumSubscribePageData } from '../utils/freemiumSubscribePageStorage';

import type { AccountResponse } from '@ltvco/refresh-lib/v1';

export const useFirstRecordSearch = (
  account: AccountResponse | undefined,
): void => {
  const navigate = useNavigate();
  const { routingUtils } = useContext(AppConfig);
  const { isFreePlan } = usePermissions();

  const freemiumSubscribePageData = getFreemiumSubscribePageData();
  const comesFromSkipSubscribePageFlow = freemiumSubscribePageData.skip_page;

  useFirstRecordSearchRedirect({
    account,
    routingUtils,
    navigate,
    beforeRedirect: () => {
      const hasSkippedSubscribePage =
        account?.account?.user_settings?.hide_freemium_upgrade_prompt === true;

      if (
        isFreePlan &&
        !hasSkippedSubscribePage &&
        !comesFromSkipSubscribePageFlow
      ) {
        navigate('/subscribe');
        return false;
      }
    },
  });
};
